import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';

interface FilterIconProps {
  icon: IconDefinition;
  /** @deprecated disabled prop is not currently used but kept for API compatibility */
  disabled?: boolean;
}

const FilterIcon: React.FC<FilterIconProps> = ({ icon }) => {
  return (
    <div className="w-4 h-5 text-neutral-600 flex items-center justify-center">
      <Icon icon={icon} className="w-5 h-5" />
    </div>
  );
};

export default FilterIcon;
